module.exports = __webpack_public_path__ + "static/media/pay-tips-2.b45e31f7.jpg";